import startCase from "lodash/fp/startCase";
import map from "lodash/fp/map";
import constants from "../../core/constants";

class Controller {
  constructor(
    $stateParams,
    ManualInvoiceItemTransforms,
    Sections,
    Events,
    InvoiceItemType
  ) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.invoiceId = $stateParams.id;
    this.sections = Sections.settingsSections;
    this.ManualInvoiceItemTransforms = ManualInvoiceItemTransforms;
    this.Events = Events;
    this.InvoiceItemType = InvoiceItemType;

    this.updateEvent = this.Events.getUpdateEvent("manualInvoiceItem");
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.onCountrySelectEvent = this.Events.getUpdateEvent("Country");

    this.editCityDisabled = true;
  }

  $onInit() {
    this.Events.on(this.updateEvent, this.updateInvoice.bind(this));
    this.Events.on(this.onCountrySelectEvent, this.onCountrySelect.bind(this));

    this.InvoiceItemType.get(this.invoiceId, {
      minimize: true,
      isCityRequired: false,
    }).$promise.then(
      (response) => {
        this.manualInvoiceItem = this.ManualInvoiceItemTransforms.justify(
          response
        );
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  updateInvoice({ key, value }) {
    const item = {
      [key]: value,
    };
    this.InvoiceItemType.update(this.invoiceId, item).$promise.then(
      (response) => {
        this.manualInvoiceItem = this.ManualInvoiceItemTransforms.justify(
          response
        );

        if (key === "cities") {
          this.citiesForm.$setPristine();
          this.editCityDisabled = true;
        }

        this.Events.emit(this.successNotificationEvent, {
          message: `${startCase(key)} has been updated successfully`,
        });
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  submitCitiesMaximum() {
    const formatMaximum = ({ maximum_limit: maximumLimit, ...values }) => ({
      maximum_limit: maximumLimit * constants.currencyBy,
      ...values,
    });

    const formattedCities = map(formatMaximum)(this.cities);

    const item = {
      key: "cities",
      value: formattedCities,
    };

    this.updateInvoice(item);
  }

  onCountrySelect({ _id: cityId }) {
    this.InvoiceItemType.getCountryCities(this.invoiceId, cityId)
      .$promise.then((response) => {
        this.cities = response;
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItem/manualInvoiceItem.controller.js